import React, { useCallback } from 'react'
import ButtonsModal from '../../../Elements/modal/ButtonsModal'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setPickupMonitorSelectedOrder, sepPickupMonitorShowPaymentModal, setPickupMonitorShowOptionsModal } from '../../../../redux/action/pickupMonitor'
import { selectTotalSum } from '../../../../redux/selector/pickupMonitor'

const EVENT_Z_INDEX = 123

const ModalOptions = React.memo(({ setShouldCompleteOrder }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const totalSum = useSelector(selectTotalSum)
	const isOpen = useSelector(state => state.pickupMonitor.modal.showOptions)

	const handleClose = useCallback(() => {
		dispatch(setPickupMonitorShowOptionsModal(false))
		dispatch(setPickupMonitorSelectedOrder(null))
	}, [dispatch])

	const handlePayment = useCallback(() => {
		dispatch(sepPickupMonitorShowPaymentModal(true))
		dispatch(setPickupMonitorShowOptionsModal(false))
	}, [dispatch])

	const handlePaymentAndComplete = useCallback(() => {
		setShouldCompleteOrder(true)
		handlePayment()
	}, [setShouldCompleteOrder, handlePayment])

	const buttons = [
		{ icon: 'bill ', text: t('order.modal.order_pay_complete'), onClick: handlePaymentAndComplete, show: true },
		{ icon: 'payment', text: t('order.modal.order_pay'), onClick: handlePayment, show: true },
	]

	return (
		<ButtonsModal isOpen={isOpen}
									close={handleClose}
									id="pickup-monitor-options-modal"
									title={t('order.modal.without_number')}
									titlePrice={totalSum}
									zIndex={EVENT_Z_INDEX}
									returnZIndex={0}
									size="small"
									buttons={buttons}
		/>
	)

})
ModalOptions.displayName = 'ModalOptions'
export default ModalOptions
